/*

  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign

  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page

  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner

*/
(function(){

	"use strict";

	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;

  var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if(shippingCalcExist) return;

	/* The ID of the element that you want to add the shipping fields into */
  var productSection = document.querySelector('.shopping-calculator');
	if(!productSection){ log('Could not find the element'); return }

	/* the main product select element */
	var productSelect = document.querySelector('.product-form form input[name="id"]');
	if(!productSelect){ log('Could not find the main select element'); return }

	/* create a message box */
	var shippingMessage = document.createElement('div');
	shippingMessage.className = 'shipping-calc-results';
	var shippingAddress = document.createElement('div');
	shippingAddress.className = 'shipping-calc-address';
	shippingAddress.hidden = true;
	var shippingResultCard = document.createElement('div');
	shippingResultCard.className = 'shipping-calc-result-card';
	shippingResultCard.hidden = true;
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');
	var shippingCalcUnknownZip;
	var shippingZipError;
	var shippingCalcWrapper;

	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function(){

		/* create the country picker */
		var countries = ['Brazil'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';

		/* Province is filled after validating the CEP. */
		shippingProvince.add(new Option('', '', true, true));
		shippingProvince.name = 'shipping_address[province]';

		/* create the zip / postcode field */
		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';
    shippingZip.value = '';
    shippingZip.placeholder = 'Insira seu CEP';

		/* create a wrapper for the fields */
		shippingCalcWrapper = document.createElement('div');
		shippingCalcWrapper.className = 'shipping-calc-wrapper';

		shippingZipError = document.createElement('div');
		shippingZipError.className = 'shipping-calc-zip-error';
		shippingZipError.hidden = true;
		var shippingZipErrorText = document.createElement('strong');
		shippingZipErrorText.textContent = 'CEP inválido.';

		shippingCalcUnknownZip = document.createElement('a');
		shippingCalcUnknownZip.className = 'link shipping-calc-unknown-zip';
		shippingCalcUnknownZip.href = 'https://buscacepinter.correios.com.br/app/endereco/index.php';
		shippingCalcUnknownZip.target = '_blank';
		shippingCalcUnknownZip.rel = 'noopener noreferrer';
		shippingCalcUnknownZip.textContent = 'Não sei o meu CEP';
		shippingZipError.appendChild(shippingZipErrorText);
		shippingZipError.appendChild(shippingCalcUnknownZip);
		shippingZip.addEventListener('input', function() {
			shippingZipError.hidden = true;
		});

		/* create a title */
		var shippingCalcTitle = document.createElement('h3');
		shippingCalcTitle.textContent = 'Frete e prazo de entrega';

		/* create a get rates button */
		var shippingCalcButton = document.createElement('button');
		shippingCalcButton.innerText = 'Calcular';
		shippingCalcButton.className = 'button shippingCalcButton';
		shippingCalcButton.onclick=function(){
			if(!productSelect.value.length){ return false }
			var zipDigits = String(shippingZip.value || '').replace(/\D/g, '');
			if(zipDigits.length !== 8){
				shippingZipError.hidden = false;
				return false;
			}
			shippingZipError.hidden = true;
			if(shippingZip.value != ''){
				shippingCalcButton.innerText = 'Calculando...';
				shippingCalcButton.className += ' disabled';
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				log('cookie found');
			}

			/* if found but has a weird length, bail */
			if(cartCookie.length < 32){ log('cart ID not valid');return }

			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));

			getRates(parseInt(productSelect.value));
			return false;
		};

		/* create some labels for the fields */
		var labelNames = ['CEP'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};

		shippingCalcWrapper.appendChild(shippingCalcTitle);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingCountry);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingProvince);
		// shippingCalcWrapper.appendChild(labels[1]);
		shippingCalcWrapper.appendChild(shippingZip);
		shippingCalcWrapper.appendChild(shippingCalcButton);
		shippingCalcWrapper.appendChild(shippingZipError);
		shippingResultCard.appendChild(shippingAddress);
		shippingResultCard.appendChild(shippingMessage);
		shippingCalcWrapper.appendChild(shippingResultCard);

		/* add to the page */
		productSection.appendChild(shippingCalcWrapper);

	};

	/* A console logging function */
	function log (a){
		if(!debug){ return }
		console.log(a);
	};

	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};

	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};

	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};

	/* format the estimated delivery date using the same business-day rule as the cart */
	var getDeliveryDate = function(rate) {
		var deliveryDays = Array.isArray(rate.delivery_days) ? parseInt(rate.delivery_days[0], 10) : null;
		if (!deliveryDays || deliveryDays < 1) return '';

		var date = new Date();
		var remainingDays = deliveryDays;

		while (remainingDays > 0) {
			date.setDate(date.getDate() + 1);
			var day = date.getDay();
			if (day !== 0 && day !== 6) remainingDays -= 1;
		}

		return new Intl.DateTimeFormat('pt-BR', {
			day: '2-digit',
			month: '2-digit'
		}).format(date);
	};

	var escapeHTML = function(value) {
		return String(value).replace(/[&<>"']/g, function(character) {
			return {
				'&': '&amp;',
				'<': '&lt;',
				'>': '&gt;',
				'"': '&quot;',
				"'": '&#039;'
			}[character];
		});
	};

	var formatZip = function(value) {
		var digits = String(value || '').replace(/\D/g, '').slice(0, 8);
		return digits.length === 8 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
	};

	var showAddress = function(address, zip) {
		if (!shippingCalcWrapper || !address || address.erro) return;

		var locationParts = [];
		if (address.logradouro) locationParts.push(address.logradouro);
		if (address.localidade) locationParts.push(address.localidade + (address.uf ? '/' + address.uf : ''));

		shippingAddress.innerHTML = '';
		var addressTitle = document.createElement('strong');
		addressTitle.textContent = locationParts.join(' – ');

		var addressMeta = document.createElement('span');
		addressMeta.textContent = 'CEP: ' + formatZip(zip) + ' ';

		var changeZipButton = document.createElement('button');
		changeZipButton.type = 'button';
		changeZipButton.className = 'shipping-calc-change-zip';
		changeZipButton.textContent = 'Verificar outro CEP';
		changeZipButton.addEventListener('click', function() {
			shippingCalcWrapper.classList.remove('has-zip-result');
			shippingResultCard.hidden = true;
			shippingAddress.hidden = true;
			shippingMessage.innerHTML = '';
			shippingZip.focus();
			shippingZip.select();
		});

		addressMeta.appendChild(changeZipButton);
		shippingAddress.appendChild(addressTitle);
		shippingAddress.appendChild(addressMeta);
		shippingAddress.hidden = false;
		shippingResultCard.hidden = false;
		shippingCalcWrapper.classList.add('has-zip-result');
	};

	var lookupAddress = function(zip) {
		var digits = String(zip || '').replace(/\D/g, '');
		if (digits.length !== 8) return Promise.resolve();

		return fetch('https://viacep.com.br/ws/' + digits + '/json/')
			.then(function(response) {
				if (!response.ok) throw new Error('CEP lookup failed');
				return response.json();
			})
			.then(function(address) {
				if (address && address.erro) {
					shippingZipError.hidden = false;
					return null;
				}
				if (!address || !address.uf) throw new Error('CEP without province');
				shippingProvince.innerHTML = '';
				shippingProvince.add(new Option(address.uf, address.uf, true, true));
				showAddress(address, digits);
				return address;
			})
			.catch(function(error) {
				shippingAddress.hidden = true;
				throw error;
			});
	};

	/* get the rates */
	var getRates = function(variantId){
		/* add whatever sanity checks you need in addition to the one below */
		if(typeof variantId === 'undefined'){ return }

		/* the main quantity element - get the one from product page, not cart drawer */
		var quantityInputs = document.querySelectorAll('.quantity__input');
		var productQuantity = null;
		
		// Find the quantity input that's NOT in the cart drawer
		for (var i = 0; i < quantityInputs.length; i++) {
			var input = quantityInputs[i];
			// Skip if it's inside cart drawer or mini cart
			if (!input.closest('cart-drawer') && 
			    !input.closest('.cart-drawer') && 
			    !input.closest('.mini-cart') &&
			    !input.closest('[data-cart-drawer]')) {
				productQuantity = input;
				break;
			}
		}
		
		// Fallback to first input if none found outside cart
		if (!productQuantity && quantityInputs.length > 0) {
			productQuantity = quantityInputs[0];
		}

		var quantity = productQuantity ? parseInt(productQuantity.value):1;
		var addressLookup = lookupAddress(shippingZip.value);
		shippingResultCard.hidden = false;
		var minimumLoadingTime = new Promise(function(resolve) {
			setTimeout(resolve, 700);
		});
		shippingMessage.setAttribute('role', 'status');
		shippingMessage.setAttribute('aria-live', 'polite');
		shippingMessage.innerHTML = '<div class="shipping-calc-loading"><span class="shipping-calc-spinner" aria-hidden="true"></span><span>Buscando o melhor pre&ccedil;o de frete...</span></div>';
		
		// Show loading state
		var calcButton = document.querySelector('.shippingCalcButton');
		if (calcButton) {
			calcButton.innerText = 'Calculando...';
			calcButton.disabled = true;
		}

		// Use the original approach with add.js - it works better
		var addData = {
			'id': variantId,
			'quantity': quantity
		};

		
		Promise.all([addressLookup, minimumLoadingTime])
		.then(function(results) {
			if (!results[0]) throw new Error('Invalid CEP');
			return fetch('/cart/add.js', {
				body: JSON.stringify(addData),
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With':'xmlhttprequest'
				},
				method: 'POST'
			});
		})
		.then(function(response) {
			if (!response.ok) {
				return response.text().then(function(text) {
					throw new Error('Cart add failed: ' + response.status);
				});
			}
			return response.json();
		})
		.then(function(json) {
			// Immediately request shipping rates after adding product
			return fetch('/cart/shipping_rates.json?' + new URLSearchParams({
				'shipping_address[country]':shippingCountry.value,
				'shipping_address[province]':shippingProvince.value,
				'shipping_address[zip]':shippingZip.value
			}));
		})
		.then(function(response) {
			if (!response.ok) {
				return response.text().then(function(text) {
					throw new Error('Shipping rates request failed: ' + response.status);
				});
			}
			return response.json();
		})
		.then(function(result) {
			if(result.shipping_rates && result.shipping_rates.length){
				let messageHtml = '<ul>';
				for (let i = 0; i < result.shipping_rates.length; i++) {
					const element = result.shipping_rates[i];
					const isFreeShipping = (Number.parseFloat(element.price) || 0) === 0;
					const formattedPrice = isFreeShipping
						? 'Frete Grátis'
						: `R$ ${element.price.replace('.', ',')}`;
					const deliveryDate = getDeliveryDate(element);
					messageHtml += `
					<li>
						<span class="shipping-calc-rate"><span>${escapeHTML(element.name)}:</span> <b${isFreeShipping ? ' class="shipping-calc-free"' : ''}>${formattedPrice}</b></span>
						${deliveryDate ? `<span class="shipping-calc-delivery">Entrega até dia: <b>${deliveryDate}</b></span>` : ''}
					</li>
					`;
				}
				messageHtml += '</ul>';
				shippingMessage.innerHTML = messageHtml;
			} else {
				shippingMessage.innerHTML = '<p>Não foi possível calcular o frete para este CEP.</p>';
			}
		})
		.catch(function(err) {
			shippingMessage.innerHTML = '<p>Erro ao calcular frete. Tente novamente.</p>';
		})
		.finally(function() {
			// Always reset button and cookie state
			if (calcButton) {
				calcButton.innerText = 'Calcular';
				calcButton.disabled = false;
				calcButton.className = 'button shippingCalcButton';
			}
			resetCartCookie();
		});

	};

	initFields();
})()
